import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom'
import '@/styles/components/exam/examPreviw/index.less'
import { component_tool } from '../../tool'
import { Descriptions } from 'antd'

let {
    WizComponent,
    WizRow,
    WizCol,
    WizTypography,
    WizBizcharts,
    WizDataSet,
} = component_tool;
let {
    Chart,
    Geom,
    Axis,
    Tooltip,
    Coord,
    Legend,
    Guide,
} = WizBizcharts
const { Title, Text, Paragraph } = WizTypography

export default class ChartsInfo extends WizComponent {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    propsAndStateOnChange = {
        percentProps: this._percentProps.bind(this)
    }

    _percentProps(nextProps, nextState) {
        this._renderPercent(nextProps.percentProps || {})
        return true;
    }

    componentDidMount() {
        let { percentProps } = this.props;
        this._renderPercent(percentProps);
        this.innerWidth = window.innerWidth
        this.autoSize = setInterval(() => {
            if (this.innerWidth != window.innerWidth) {
                this._renderPercent(this.props.percentProps || {});
                this.innerWidth = window.innerWidth
            }
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.autoSize)
    }

    /**
     * 渲染percent
     */
    _renderPercent = (props) => {
        let { data, count, dataFormat, centerText,colors, key } = props || this.props
        const { DataView } = WizDataSet
        const dv = new DataView()
        const { Html } = Guide;
        dv.source(data).transform(dataFormat);
        const cols = {
            percent: {
                formatter: val => {
                    val = (val * 100).toFixed(2) + "%";
                    return val;
                }
            }
        };
        let o = document.getElementById("_content"+key);
        // let pHeight = o.offsetWidth * 0.3
        let pHeight = 300
        let pWidth = o.offsetWidth
        ReactDOM.render((
            <Chart
                height={pHeight}
                width={pWidth}
                data={dv}
                scale={cols}
                padding={{ top: 20, left: -pWidth * 0.2, bottom: 20 }}
            >
                <Coord type={"theta"} radius={0.8} innerRadius={0.8} />
                <Axis name="percent" />
                <Legend
                    clickable={false}
                    position="right"
                    offsetY={-pHeight * 0.3}
                    offsetX={-pWidth * 0.4}
                    textStyle={{
                        textAlign: 'start', // 文本对齐方向，可取值为： start middle end
                        fill: 'black', // 文本的颜色
                        fontSize: '13', // 文本大小
                        //fontWeight: 'bold', // 文本粗细
                        textBaseline: 'middle' // 文本基准线，可取 top middle bottom，默认为middle
                    }}
                    itemFormatter={val => {
                        let p = 0;
                        let c = 0;
                        data.forEach(d => {
                            if (d['item'] === val) {
                                if (count === 0) {
                                    count = 1;
                                }
                                p = (d['count'] * 100 / count).toFixed(2) + "%"
                                c = d['count']
                            }
                        });
                        return val + '  |  ' + p + '  |  ' + c + '  人  '; // val 为每个图例项的文本值
                    }}

                />
                <Tooltip
                    showTitle={false}
                    itemTpl="<li><span style=&quot;background-color:{color};&quot; class=&quot;g2-tooltip-marker&quot;></span>{name}: {value}</li>"
                />
                <Guide>
                    <Html
                        position={["50%", "50%"]}
                        html={() => {
                            return `<div style="text-align:center;font-size:1.1em">${centerText}<br/><span style="color:black;font-size:2em">${count}</span></div>`;
                        }}
                        alignX="middle"
                        alignY="middle"
                    />
                </Guide>
                <Geom
                    type="intervalStack"
                    position="percent"
                    color={['item',colors]}
                    tooltip={[
                        "item*percent",
                        (item, percent) => {
                            percent = (percent * 100).toFixed(2) + "%";
                            return {
                                name: item,
                                value: percent
                            };
                        }
                    ]}
                    style={{
                        lineWidth: 1,
                        stroke: "#fff"
                    }}
                >
                </Geom>
            </Chart>
        ), document.getElementById(key));
    }

    /**
     * 中间部分：统计图表
     */
    _content = (key) => {
        return (
            <WizRow id={'_content'+key} type={'flex'} align={'middle'}>
                <div id={key}></div>
                <div style={{ padding: 10 }}>
                    {this._items(key)}
                </div>
            </WizRow>
        )
    }

    /**
     * 图标边上的统计项
     */
    _items = (key) => {
        let { itemProps } = this.props;
        let r = []
        if (!itemProps.length) {
            return r;
        }
        let padding = { style: { padding: 8 } }
        let lessFont = { style: { padding: 8, color: '#66666' } }
        let mainFont = { style: { padding: 8, color: '#3a3a3a' } }
        itemProps.forEach(item => {
            if (item['title'] && item['value']) {
                let img = item['img'] ? <img src={item['img']} style={{ height: 25, width: 25 }} /> : null
                r.push(
                    <WizRow {...padding}>
                        <span {...padding}>{img}</span>
                        <span {...lessFont}>{item['title']}</span>
                        <span {...mainFont}>{item['value']}</span>
                    </WizRow>
                )
            }
        });
        return r;
    }

    /**
     * 尾部：其他信息展示
     */
    _footer = (footerView) => {
        return footerView
    }

    render() {
        let { footerView, percentProps} = this.props;
        let {key} = percentProps
        return (
            <>
                {this._content(key)}
                {this._footer(footerView)}
            </>
        )

    }
}

/**
 * 默认值
 */
ChartsInfo.defaultProps = {
    percentProps: {
        data: [],
        dataFormat: {},
        count: 0
    },
    itemProps: []
}

/**
 * props入参校验
 */
ChartsInfo.propTypes = {
    /**
     * percent的参数
     */
    percentProps: PropTypes.obj,
    /**
     * 统计条目内容 [{img,title,value}]
     */
    itemProps: PropTypes.array,
    /**
     * 底部的展示
     */
    footerView: PropTypes.any

}
